import { instance } from "libs/api";

import { Category } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";
import { UpdateSubCategoryPayload } from "./updateSubCategory.types";

export const requestUpdateSubCategory = async (
  body: UpdateSubCategoryPayload
): Promise<Category> => {
  return await instance.put(ApiRoutesCategories.SubCategory, body);
};
